export default __webpack_public_path__ + "static/media/bnb-fine.9c246cca.svg";